import { define, auto, type } from 'type-r'
import Vue from 'vue'

import { currentStore as store } from '@models/sitestore'
import { BaseComponent } from 'jn_base'
import MenuItemSlot, {MenuItemSlotCollection} from '@models/menu_slot'

var CustomMenuVue = Vue.extend({
    mixins: [BaseComponent],
    data: function() {
	store.menu.on("change", (this as InstanceType<typeof CustomMenuVue>).renderPrice, this);
	jQuery("form.cart").submit((evt) => (this as InstanceType<typeof CustomMenuVue>).submit(evt));
        
        return {
            menu: store.menu,
            choosing: true,
            productId: store.productId,
            qty: 1
        }
    },
    beforeMount: function() {
	jQuery(".single_add_to_cart_button").prop("disabled", false);        
    },
    methods: {
        submit: function(evt:any) {
            this.qty = jQuery("[name='quantity']").val(); 
            if (this.menu.validationError) {
                evt.stopPropagation();
                evt.preventDefault();
                evt.stopImmediatePropagation();
	        alert("Please select your custom menu before adding to cart.");
	        return false;
            }
	    var menudata = this.menu.toData();
	    menudata.productId = this.productId;
	    var val = $('[name="quantity"]').val();
	    menudata.qty = val;
            // converts model to Bookly compliant form inputs for submitting
            this.choosing = false;
            jQuery("[name='quantity']").closest("form").append(`<input name='menu' id='menu1' type='hidden'/>`);
            jQuery("#menu1").val(JSON.stringify(menudata));
	    jQuery("form.cart").block({message:"Adding to cart..."});
	    return true;
        },
        renderPrice: function() {
	    var price = this.menu.getPrice();
	    jQuery(".price-wrapper .woocommerce-Price-amount.amount bdi").html('<span class="woocommerce-Price-currencySymbol">$</span>' + price.toFixed(2));
        }
    }
});

export default CustomMenuVue;
